import './App.css'
import React from 'react'
import { useWindowSize } from 'usehooks-ts'
import { ConfigProvider, theme } from 'antd'
import huHU from 'antd/locale/hu_HU'
import { useMemo } from 'react'
import { ResponsiveContext } from './context/responsive-context'
import TimeElapsedCounter  from './components/Elapsed'
import { AudioPlayer } from './components/AudioPlayer'

function App() {
  const { width } = useWindowSize()
  const { token } = theme.useToken()
  const isMobile = useMemo(() => width < token.screenXSMax, [width, token.screenXSMax])
  const useVertical = token.screenLGMin > width
  return (
    <ConfigProvider locale={huHU} theme={{
      token: {
        screenSM: 577,
        screenSMMin: 577,
        screenXSMax: 576,
        screenLG: 1110,
        screenLGMin: 1110,
        screenMDMax: 1109,
      },
    }}>
      <ResponsiveContext value={{
        isMobile,
        useVertical
      }}>
        <TimeElapsedCounter targetDate={new Date(2026, 3, 13, 8, 0, 0)} />
        <AudioPlayer />
      </ResponsiveContext>
    </ConfigProvider>
  )
}

export default App




  // <div style={{
  //   display: 'flex',
  //   flexDirection: 'column',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   padding: '1.5rem 1rem',
  //   backgroundColor: '#ffffff',
  //   borderRadius: '16px',
  //   boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  //   border: '1px solid #f3f4f6',
  //   minWidth: '65px'
  // }}>
  //   <span style={{
  //     fontSize: '1.875rem',
  //     fontWeight: 300,
  //     color: '#1f2937',
  //     fontVariantNumeric: 'tabular-nums'
  //   }}>
  //     {value.toString().padStart(2, '0')}
  //   </span>
  //   <span style={{
  //     fontSize: '0.65rem',
  //     textTransform: 'uppercase',
  //     letterSpacing: '0.1em',
  //     color: '#9ca3af',
  //     fontWeight: 600,
  //     marginTop: '4px'
  //   }}>
  //     {label}
  //   </span>
  // </div>
